/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TrackingMelcoModelsCustomWarning,
    TrackingMelcoModelsCustomWarningFromJSON,
    TrackingMelcoModelsCustomWarningFromJSONTyped,
    TrackingMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface TrackingMelcoModelsLogData
 */
export interface TrackingMelcoModelsLogData {
    /**
     * 
     * @type {number}
     * @memberof TrackingMelcoModelsLogData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoModelsLogData
     */
    file_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoModelsLogData
     */
    device_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoModelsLogData
     */
    category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoModelsLogData
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TrackingMelcoModelsLogData
     */
    created_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoModelsLogData
     */
    product_code?: string | null;
    /**
     * 
     * @type {Array<TrackingMelcoModelsCustomWarning>}
     * @memberof TrackingMelcoModelsLogData
     */
    warning_list?: Array<TrackingMelcoModelsCustomWarning> | null;
}

export function TrackingMelcoModelsLogDataFromJSON(json: any): TrackingMelcoModelsLogData {
    return TrackingMelcoModelsLogDataFromJSONTyped(json, false);
}

export function TrackingMelcoModelsLogDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingMelcoModelsLogData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'device_name': !exists(json, 'device_name') ? undefined : json['device_name'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'created_on': !exists(json, 'created_on') ? undefined : (new Date(json['created_on'])),
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(TrackingMelcoModelsCustomWarningFromJSON)),
    };
}

export function TrackingMelcoModelsLogDataToJSON(value?: TrackingMelcoModelsLogData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'file_name': value.file_name,
        'device_name': value.device_name,
        'category': value.category,
        'description': value.description,
        'created_on': value.created_on === undefined ? undefined : (value.created_on.toISOString()),
        'product_code': value.product_code,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(TrackingMelcoModelsCustomWarningToJSON)),
    };
}


